var _defs, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3, _path6, _polyline, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab7449ec-0913-47bc-8a6e-913366026d0f",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ac282ba0-99db-40ae-8f9e-e5fe44913e25,.fd92480d-121b-488e-8344-6ccf9d7749c3{fill:none;}.ac282ba0-99db-40ae-8f9e-e5fe44913e25,.eea66f22-4a5f-4e41-bf8e-d364d2b95c0b{stroke:#8e8e8e;}.ac282ba0-99db-40ae-8f9e-e5fe44913e25,.eea66f22-4a5f-4e41-bf8e-d364d2b95c0b,.f1e8d23b-56b0-45ec-ae15-4185d30865c8,.fd92480d-121b-488e-8344-6ccf9d7749c3{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.abe2bcb7-1cfa-41c2-8b95-24d01ac4d5f9,.eea66f22-4a5f-4e41-bf8e-d364d2b95c0b{fill:#68b21d;}.abbfba81-5a80-4923-a1eb-41ca0db07120{fill:#fff;}.f1e8d23b-56b0-45ec-ae15-4185d30865c8,.fd92480d-121b-488e-8344-6ccf9d7749c3{stroke:#645346;}.f1e8d23b-56b0-45ec-ae15-4185d30865c8{fill:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ac282ba0-99db-40ae-8f9e-e5fe44913e25",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "eea66f22-4a5f-4e41-bf8e-d364d2b95c0b",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "abe2bcb7-1cfa-41c2-8b95-24d01ac4d5f9",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "abbfba81-5a80-4923-a1eb-41ca0db07120",
    d: "M43,70.7a4.5,4.5,0,0,0,2.4.7c1.3,0,2.1-.7,2.1-1.7s-.6-1.5-1.9-2-2.7-1.5-2.7-2.9,1.3-2.7,3.3-2.7a4.2,4.2,0,0,1,2.2.5l-.4,1a3.6,3.6,0,0,0-1.9-.5,1.7,1.7,0,0,0-1.9,1.6c0,.9.6,1.4,2,1.9s2.6,1.5,2.6,3-1.2,2.9-3.5,2.9a4.7,4.7,0,0,1-2.6-.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "abbfba81-5a80-4923-a1eb-41ca0db07120",
    d: "M52.8,72.3,49.5,62.2h1.4l1.6,5c.4,1.4.8,2.6,1.1,3.8h0a33,33,0,0,1,1.2-3.8l1.7-5h1.4L54.2,72.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "abbfba81-5a80-4923-a1eb-41ca0db07120",
    d: "M66.6,71.9a9.3,9.3,0,0,1-3.1.5,4.7,4.7,0,0,1-5.1-5.1c0-3,2-5.2,5.4-5.2a5.9,5.9,0,0,1,2.5.5l-.3,1a5.7,5.7,0,0,0-2.2-.4,3.8,3.8,0,0,0-4.1,4.1,3.7,3.7,0,0,0,3.9,4l1.8-.2v-3H63.3V67h3.3Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "fd92480d-121b-488e-8344-6ccf9d7749c3",
    x: 37.2,
    y: 48.9,
    width: 4.6,
    height: 4.58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "fd92480d-121b-488e-8344-6ccf9d7749c3",
    x: 59,
    y: 27.8,
    width: 4.6,
    height: 4.58
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fd92480d-121b-488e-8344-6ccf9d7749c3",
    d: "M39.5,48.9A18.7,18.7,0,0,1,58.2,30.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "fd92480d-121b-488e-8344-6ccf9d7749c3",
    points: "49.7 45 48.4 39.5 53.9 40.8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "f1e8d23b-56b0-45ec-ae15-4185d30865c8",
    x: 42.7,
    y: 33.8,
    width: 4.6,
    height: 4.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.55c7e6cb7f5f969bbe13658f8fb0fb2f.svg";
export { ForwardRef as ReactComponent };